import { t } from '../i18n/dictionaries'
import type { Locale } from '../site'
import { NAV, NAV_ICONS } from './nav'
import type { PageId } from './shell'

export function renderChrome(locale: Locale, pageId: PageId): void {
  const host = document.querySelector('[data-mount-chrome]')
  if (!host) return

  const navGroup = (label: string, items: readonly { id: string; href: string; key: string; icon: string }[]) => `
    <div class="app-sidebar__group">
      <p class="app-sidebar__label">${t(locale, label)}</p>
      ${items
        .map(
          (item) => `
            <a class="glass-nav-item" data-nav="${item.id}" href="${item.href}">
              <span class="glass-nav-item__icon" aria-hidden="true">${item.icon}</span>
              <span>${t(locale, item.key)}</span>
            </a>`,
        )
        .join('')}
    </div>`
  const contentNav = [
    { id: 'qa', href: '/qa/index.html', key: 'nav_qa', icon: NAV_ICONS.question },
    { id: 'article', href: '/articles/screen-buying-guide.html', key: 'nav_articles', icon: NAV_ICONS.article },
  ] as const

  host.innerHTML = `
    <div class="app-shell${pageId === 'home' ? ' app-shell--home' : ''}">
      <header class="app-top">
        <div class="glass-bar">
          <div class="glass-bar__inner glass-group">
            <a class="app-brand" href="/index.html">
              <span class="app-brand__mark" aria-hidden="true"></span>
              <span class="app-brand__text"><strong>${t(locale, 'brand')}</strong><small>DISPLAY LAB</small></span>
            </a>
            <nav class="seg-desktop glass-group" aria-label="Primary">
              <a class="glass-chip" data-nav="home" href="/index.html">${t(locale, 'nav_home')}</a>
              <a class="glass-chip" data-nav="solid-color" href="/solid-color.html">${t(locale, 'solid')}</a>
              <a class="glass-chip" data-nav="uniformity" href="/uniformity.html">${t(locale, 'uniformity')}</a>
              <a class="glass-chip" data-nav="touch" href="/touch.html">${t(locale, 'touch_tool')}</a>
              <a class="glass-chip" data-nav="qa" href="/qa/index.html">${t(locale, 'nav_qa')}</a>
            </nav>
            <div class="app-top__spacer"></div>
            <div class="app-top__actions">
              <a class="glass-chip top-cta-chip" href="/solid-color.html?start=1">${t(locale, 'start_test')}</a>
              <button type="button" class="glass-chip" data-action="lang">${t(locale, 'language')}</button>
              <div class="glass-menu" data-menu="lang" hidden>
                <button type="button" data-locale="follow">${t(locale, 'follow_system')}</button>
                <button type="button" data-locale="zh-CN">中文</button>
                <button type="button" data-locale="zh-TW">繁體中文</button>
                <button type="button" data-locale="en">English</button>
                <button type="button" data-locale="ja">日本語</button>
              </div>
              <button type="button" class="glass-chip" data-action="theme">${t(locale, 'theme')}</button>
              <div class="glass-menu" data-menu="theme" hidden>
                <button type="button" data-theme-mode="system">${t(locale, 'system')}</button>
                <button type="button" data-theme-mode="light">${t(locale, 'light')}</button>
                <button type="button" data-theme-mode="dark">${t(locale, 'dark')}</button>
              </div>
              <a class="glass-chip" href="/settings.html">${t(locale, 'nav_settings')}</a>
            </div>
          </div>
        </div>
      </header>
      <div class="app-body">
        <aside class="app-sidebar glass-panel">
          <div class="glass-panel__inner scrollbar-custom">
            <div class="app-sidebar__intro">
              <span class="status-pill">${t(locale, 'privacy_note')}</span>
            </div>
            ${navGroup('nav_quality', NAV.quality)}
            ${navGroup('nav_motion', NAV.motion)}
            ${navGroup('nav_touch', NAV.touch)}
            ${navGroup('nav_lab', NAV.lab)}
            ${navGroup('nav_content', contentNav)}
          </div>
        </aside>
        <div class="app-main" data-chrome-main></div>
      </div>
    </div>
    <nav class="app-mobile-tab" aria-label="Mobile">
      <div class="glass-tabbar">
        <div class="glass-tabbar__inner">
          <a class="glass-tab" href="/index.html"><strong>${t(locale, 'nav_home')}</strong></a>
          <a class="glass-tab" href="/solid-color.html"><strong>${t(locale, 'nav_quality')}</strong></a>
          <a class="glass-tab" href="/refresh-rate.html"><strong>${t(locale, 'nav_motion')}</strong></a>
          <a class="glass-tab" href="/touch.html"><strong>${t(locale, 'nav_touch')}</strong></a>
          <a class="glass-tab" href="/qa/index.html"><strong>${t(locale, 'nav_more')}</strong></a>
        </div>
      </div>
    </nav>
  `

  const main = document.querySelector('[data-page-content]')
  const slot = host.querySelector('[data-chrome-main]')
  if (main && slot) slot.appendChild(main)

  void pageId
}
